/**
 * /livret-passerelle-a2-a — Livret interactif Passerelle A2 → A (7 h).
 * Accessible sans compte, avec sauvegarde localStorage et sync Cloud si connecté.
 */
import React from 'react';
import LivretInteractif from '../../components/livrets/LivretInteractif';
import { LIVRET_PASSERELLE_A2A } from '../../data/livretPasserelleData';

export default function LivretPasserelleA2A() {
  return <LivretInteractif data={LIVRET_PASSERELLE_A2A} testid="livret-passerelle-a2-a" />;
}
